/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_FetchingInputs */

const en_jobs_fetching = /** @type {(inputs: Jobs_FetchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetching...`)
};

const de_jobs_fetching = /** @type {(inputs: Jobs_FetchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird abgerufen...`)
};

const fr_jobs_fetching = /** @type {(inputs: Jobs_FetchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupération en cours...`)
};

const es_jobs_fetching = /** @type {(inputs: Jobs_FetchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obteniendo...`)
};

const it_jobs_fetching = /** @type {(inputs: Jobs_FetchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recupero...`)
};

const nl_jobs_fetching = /** @type {(inputs: Jobs_FetchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ophalen...`)
};

const pl_jobs_fetching = /** @type {(inputs: Jobs_FetchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobieranie...`)
};

const fi_jobs_fetching = /** @type {(inputs: Jobs_FetchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haetaan...`)
};

const da_jobs_fetching = /** @type {(inputs: Jobs_FetchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henter...`)
};

const sv_jobs_fetching = /** @type {(inputs: Jobs_FetchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hämtar...`)
};

/**
* | output |
* | --- |
* | "Fetching..." |
*
* @param {Jobs_FetchingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_fetching = /** @type {((inputs?: Jobs_FetchingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_FetchingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_fetching(inputs)
	if (locale === "fr") return fr_jobs_fetching(inputs)
	if (locale === "es") return es_jobs_fetching(inputs)
	if (locale === "it") return it_jobs_fetching(inputs)
	if (locale === "nl") return nl_jobs_fetching(inputs)
	if (locale === "pl") return pl_jobs_fetching(inputs)
	if (locale === "fi") return fi_jobs_fetching(inputs)
	if (locale === "da") return da_jobs_fetching(inputs)
	if (locale === "sv") return sv_jobs_fetching(inputs)
	return en_jobs_fetching(inputs)
});